import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface User {
  id: string
  email: string
  display_name: string
  avatar_url?: string
  bio?: string
  roles: string[]
  points_balance?: number
  created_at?: string
  subscription_plan?: string
  email_verified?: boolean
  terms_acceptance_required?: boolean
}

interface AuthState {
  user: User | null
  /** @deprecated H1 後 access token 走 HttpOnly cookie；保留欄位避免破壞舊呼叫端，永遠為 null */
  token: null
  _hasHydrated: boolean
  /** token 參數已無作用（cookie 由後端設）；只更新 user。 */
  setAuth: (user: User, _token?: string) => void
  /** 同步打 logout 端點清 cookie；前端 user 也清空。 */
  clearAuth: () => Promise<void>
  setHasHydrated: (v: boolean) => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      _hasHydrated: false,
      setAuth: (user) => set({ user }),
      clearAuth: async () => {
        try {
          await fetch('/api/auth/logout', { method: 'POST', credentials: 'include' })
        } catch { /* ignore network errors */ }
        set({ user: null })
      },
      setHasHydrated: (v) => set({ _hasHydrated: v }),
    }),
    {
      name: 'pixeltravel-auth',
      partialize: (s) => ({ user: s.user }),
      onRehydrateStorage: () => (state, error) => {
        // H1 遷移：清掉殘留的舊 localStorage token，避免被誤讀
        try { localStorage.removeItem('access_token') } catch { /* ignore */ }
        if (error) {
          useAuthStore.getState().setHasHydrated(true)
        } else {
          state?.setHasHydrated(true)
        }
      },
    },
  ),
)
